import { useEffect, useState } from 'react'
import PastAuctionsTable from 'src/pages/fuel-trading/past-auctions/past-auctions-table'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { IAuctionWithFuelTradingOrders } from 'src/_models/auction.model'
import { useSearchParams } from 'react-router-dom'

const FuelTradingPastAuctionsPage = () => {
  const [auctions, setAuctions] = useState<IAuctionWithFuelTradingOrders[]>([])
  const [searchParams, _] = useSearchParams()

  const params = searchParams.toString()
  const orderInProgressQuery = useQuery({
    queryKey: ['auctions', 'auctions/past-auctions', params],
    queryFn: () => {
      const token = localStorage.getItem('token')
      return axios.get<{ auctions: IAuctionWithFuelTradingOrders[] }>(`/api/past-auctions?${params}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    },
  })

  useEffect(() => {
    if (orderInProgressQuery.data) {
      setAuctions(orderInProgressQuery.data.data.auctions)
    }
  }, [orderInProgressQuery.data])

  return (
    <>
      <section className="w-full">
        <PastAuctionsTable heading="Past Auctions" auctions={auctions} />
      </section>
    </>
  )
}

export default FuelTradingPastAuctionsPage
